/**
 * UTM Parameter Utilities
 * 
 * Provides functions to capture, store, and retrieve UTM parameters from URL
 */

// Store UTM parameters from URL to localStorage
export const captureUtmParams = () => {
  try {
    const urlParams = new URLSearchParams(window.location.search);
    const utmSource = urlParams.get('utm_source');
    const utmMedium = urlParams.get('utm_medium');
    const utmCampaign = urlParams.get('utm_campaign');
    
    // Only store non-null parameters
    if (utmSource) localStorage.setItem('utm_source', utmSource);
    if (utmMedium) localStorage.setItem('utm_medium', utmMedium);
    if (utmCampaign) localStorage.setItem('utm_campaign', utmCampaign);

    return {
      utmSource,
      utmMedium,
      utmCampaign
    };
  } catch (error) {
    console.error('Error capturing UTM parameters:', error);
    return {};
  }
};

// Get UTM parameters from localStorage
export const getUtmParams = () => {
  try {
    return {
      utmSource: localStorage.getItem('utm_source') || null,
      utmMedium: localStorage.getItem('utm_medium') || null,
      utmCampaign: localStorage.getItem('utm_campaign') || null
    };
  } catch (error) {
    console.error('Error retrieving UTM parameters:', error);
    return {
      utmSource: null,
      utmMedium: null,
      utmCampaign: null
    };
  }
};

// Clear UTM parameters from localStorage (after registration/conversion)
export const clearUtmParams = () => {
  try {
    localStorage.removeItem('utm_source');
    localStorage.removeItem('utm_medium');
    localStorage.removeItem('utm_campaign');
  } catch (error) {
    console.error('Error clearing UTM parameters:', error);
  }
};

// Add UTM parameters to an existing object (for API calls)
export const addUtmParamsToObject = (obj) => {
  const utmParams = getUtmParams();
  return {
    ...obj,
    utmSource: utmParams.utmSource,
    utmMedium: utmParams.utmMedium,
    utmCampaign: utmParams.utmCampaign
  };
};
